/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_TitleInputs */



/**
* | output |
* | --- |
* | "Licence" |
*
* @param {License_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_title = /** @type {((inputs?: License_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Licence")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lizenz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Licenza")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Лицензия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Licencia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("许可证")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライセンス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइसेंस")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Licença")
	return /** @type {LocalizedString} */ ("Licence")
});